// ============================================================================
// ACTIVITY ENDPOINTS
// ============================================================================
// URL builders for the Activity master.
// Backend controller: ActivitiesController → /api/v1/Activities

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Activities';

export const activityEndpoints = {
  /** GET /api/v1/Activities — paginated list with filters */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/Activities/{id} */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/Activities/code/{code} */
  getByCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /** POST /api/v1/Activities */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /api/v1/Activities/{id} */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/Activities/{id} → 204 No Content on success */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** Raw path for buildEndpointWithQuery (avoids /v1/v1/ doubling) */
  basePath: () => BASE_PATH,
} as const;

export default activityEndpoints;
